<div class="modal-body">
    <button type="button" class="btn-close float-end" aria-label="Close"
        (click)="modalService.dismiss('Cross click')"></button>
    <div class="row m-0">
        <div class="col-md-12 p-0" [innerHTML]="elemento.infoAdicional">
        </div>
    </div>
</div>